import { render, staticRenderFns } from "./peClassification.vue?vue&type=template&id=8434d380&scoped=true&"
import script from "./peClassification.vue?vue&type=script&lang=js&"
export * from "./peClassification.vue?vue&type=script&lang=js&"
import style0 from "./peClassification.vue?vue&type=style&index=0&id=8434d380&prod&lang=scss&scoped=true&"
import style1 from "./peClassification.vue?vue&type=style&index=1&id=8434d380&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8434d380",
  null
  
)

export default component.exports